export const dataInitialApprovalHighAccident = () => {
    return {
        id: null,
        description: '',
        modalIsOpen: false
    }
}

export const dataInitialDetailsApproveHighAccident = () => {
    return {
        accident: {
            approval_description: '',
            approval_date: '',
            approve_user: {
                id: '',
                name: ''
            }
        },
        modalIsOpen: false
    }
}

export const dataInitialCloneHighAccident = () => {
    return {
        accident: {
            id: null,
            company_id: null,
            slq_location_id: null,
            user_creator_id: null,
            active: true,
            description: "",
            start_date: null,
            approval_description: null,
            approval_date: null,
            approval_user_id: null,
        },
        modalIsOpen: false,
    };
}

export default {
    companies: [],
    locations: [],
    filter: {
        company: {
            id: null,
            nombre: null
        },
        location_id: null,
        page: 1,
        perPage: 10,
        sortBy: "id",
        sort: "DESC",
        search: "",
        is_approved: 'all',
    },
    filterProductsInactives: {
        location_id: null,
        page: 1,
        perPage: 10,
        sortBy: "id",
        sort: "DESC",
        search: ""
    },
    accidents_high: [],
    modalCreate: {
        view: false
    },
    newAccident: {
        id: null,
        start_date: "",
        slq_location_id: null,
        description: "",
        company_id: null,
        active: true
    },
    productsByLocation: [],
    productsByAccident: {
        data: [],
        total: 0
    },
    productsNotPpamByLocation: [],
    productsByInactiveLocation: [],
    filterProducts: {
        location_id: null,
        page: 1,
        perPage: 10,
        search: "",
        producer: {
            id: ""
        }
    },
    unitMeasures: [],
    densityUnits: [],
    location: {
        id: null,
        description: null
    },
    accidentHighId: null,
    summary: [],
    producers: [],
    modalAsigne: {
        view: false
    },
    productsNoAsigned: [],
    filterProductsNoAsigned: {
        id: null
    },
    modalCreatedProduct: {
        view: false
    },
    newAdjuntToProduct:{
        tipo: '',
        fecha: null,
        sistema: 'no',
        activo: 1,
        cumple_decreto: '',
        no_cumple: 0,
        observacion_no_cumple: '',
        idioma: '',
        observacion: '',
        estado_fds: '',
    },
    modalApprovalHighAccident: dataInitialApprovalHighAccident(),
    modalDetailsApproveHighAccident: dataInitialDetailsApproveHighAccident(),
    highAccident: null,
    modalCloneHighAccident: dataInitialCloneHighAccident(),
    list_comparative: {
        delete_locations : {
            total : 0,
            data : [],
        },
        only_locations : {
            total : 0,
            data : [],
            perPage: 10,
            page: 1,
        },
        only_add_after : {
            total : 0,
            data : [],
            perPage: 10,
            page: 1,
        }
    },
    modalProductsComparative: false,
    filterDeleteLocations : {
        perPage: 10,
        page: 1,
    },
    filterOnlyLocations : {
        perPage: 10,
        page: 1,
    },
    filterOnlyAddAfter : {
        perPage: 10,
        page: 1,
    },
};
